import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import EmisorFiscalInfoForm from './EmisorFiscalInfoForm';
import EmisorUpsertFiscalAddressForm from './EmisorFiscalAddressForm';

class EmisorUpsertFiscalInfo extends Component {
  steps = {
    fiscal_info: false,
    fiscal_address: false,
  };

  handleOnDataChange = (event) => {
    this.steps = {
      ...this.steps,
      [event.step]: event.isValid,
    };

    this.props.onDataChange({
      ...event,
      data: event.data,
      step: 'fiscal_info',
      isValid: this.steps.fiscal_info && this.steps.fiscal_address,
    });
  };

  handleOnFiscalAddressDataChange = (event) => {
    let data = {
      ...this.props.data,
      direccion: event.data,
    };

    this.handleOnDataChange({
      ...event,
      data,
    });
  };

  render() {
    const { data } = this.props;

    return (
      <Row>
        <Col
          xs={12}
          sm={12}
          md={10}
          lg={5}
        >
          <div className="py-3">
            <strong className="text-info">INFORMACIÓN FISCAL</strong>
          </div>

          <EmisorFiscalInfoForm
            data={data}
            confirm={false}
            autoFocus={true}
            onFormDataChange={this.handleOnDataChange}
          />
        </Col>

        <Col
          xs={12}
          sm={12}
          md={10}
          lg={5}
        >
          <div className="py-3">
            <strong className="text-info">DOMICILIO FISCAL</strong>
          </div>

          <EmisorUpsertFiscalAddressForm
            data={data.direccion || {}}
            onFormDataChange={this.handleOnFiscalAddressDataChange}
          />
        </Col>
      </Row>
    );
  }
}

export default EmisorUpsertFiscalInfo;
